import StudyPdf from '../studypdf/StudyPdf.vue'
export default {
  data() {
    return {
      //系统给的唯一文件名字
      updateDocRealName: '',
      //修改自定义文件的名字
      updateDocName: '',
      //修改自定义文件名字时候的文件id
      updateDocId: '',
      //自定义的文件名字
      docName: '',
      //返回上传文件的唯一名字
      fileName: '',
      idInputDisable: false,
      nameInputDisable: false,
      // keywordId:'',
      keywordType: '',
      keywordName: '',
      tableData: [
        {
          id: "123",
          name: "attean",
          type: "world"
        }
      ],
      //控制修改文件名弹出框
      dialogdoc: false,
      // 控制预览文档弹出框
      dialogPreview: false,
      // 控制对话显示
      dialogTableVisible: false,
      formLabelWidth: "120px",
      dialogTableVisible2: false,
      // currentPage: 1,
      //总页数
      totalPage: 0,
      //偏移量
      offset: '0',
      //当前页面
      currentPage: 1,
      resourceLength: 15,
      // 上传的接口
      action: this.baseUrl + 'file/upload_work?token=' + this.$store.state.authority_management,
      // 存储上传文件的数组
      fileList: [],
      // 所要预览文档的id
      studyId: null,
      // 批量上传文件需要的变量
      fileData: ''
    }
  },
  components: {
    StudyPdf
  },
  methods: {
    // 上传
    httpreq(q) {
      this.$upload(this.action, q).then(res => {
        this.fileName = res.data.result
      }).catch(err => {
        // // console.log(err)
      })
    },

    // 覆盖上传事件
    uploadFile(q) {
      this.$upload(this.action, q).then(res => {
        this.handleUploadFile(q.file.name, res.data.result)
      }).catch(err => {
        this.$message({
          showClose: true,
          message: '新增文件资源失败！',
          type: 'error'
        })
      })
    },

    // 上传文件
    handleUploadFile(fileName, dataName) {
      this.$post('resources/shop_create', { 
        token: this.$store.state.authority_management,
        name: fileName.trim(),
        data: dataName.trim(),
        type: '4',
        shop_id: this.$store.state.store.id
      }).then(res => {
        if (res.data.status == 'success') {
          this.$message({
            showClose: true,
            message: '新增文件资源成功！',
            type: 'success'
          });
          this.getData();
        }
      })
    },

    //确定更新的文档名字
    confirmUpdateDoc() {
      let data = {
        token: this.$store.state.authority_management,
        name: this.updateDocName,
        id: this.updateDocId,
        type: '4',
        data: this.updateDocRealName,
      };
      this.$post('resources/shop_edit', data).then(res => {
        if (res.data.status == 'success') {
          this.$message({
            showClose: true,
            message: '更改文件名成功',
            type: 'success'
          });
          this.getData();
          this.dialogdoc = false;
          this.updateDocName = '';
          this.updateDocId = '';
          this.updateDocRealName = '';
        } else {
          this.$message({
            showClose: true,
            message: '更改文件名失败',
            type: 'error'
          });
        }
      })
    },
    //更改资源
    hendelUpdate(name, id, realName) {
      this.dialogdoc = true;
      this.updateDocName = name;
      this.updateDocId = id;
      this.updateDocRealName = realName;
    },
    //确定提交资源插入数据库
    confirmSubmit() {
      if (this.fileName == '') {
        this.$message({
          showClose: true,
          message: '请确保你已经上传文件且上传成功',
          type: 'error'
        });
        return false;
      } else if (this.docName == '') {
        this.$message({
          showClose: true,
          message: '文件名字不能为空！',
          type: 'error'
        });
        return false;
      }
      this.$post('resources/shop_create', { token: this.$store.state.authority_management, name: this.docName, data: this.fileName, type: '4', shop_id: this.$store.state.store.id }).then(res => {
        if (res.data.status == 'success') {
          this.$message({
            showClose: true,
            message: '新增文件资源成功！',
            type: 'success'
          });
          this.dialogTableVisible = false;
          this.fileList = [];
          this.docName = '';
          this.fileName = '';
          this.getData();
        } else {
          this.$message({
            showClose: true,
            message: '新增文件资源失败！',
            type: 'error'
          });
        }

      })
    },
    onSearch() {
      let offset = 0;
      // let length = 50
      let data = { token: this.$store.state.authority_management, type: 4, id: this.keywordId, name: this.keywordName, offset: offset, length: this.resourceLength };
      // 这里调用搜索资源接口
      this.$post('resources/shop_search', data).then(res => {
        // // console.log(res)
        this.tableData = res.data.result.data
        this.totalPage = res.data.result.total
		this.currentPage = 1
      })
    },
    oncli(dataa) {
      // alert(dataa);
    },
    onReset(formName) {
      // 这里是清空修改中的内容 不用管
      this.dialogTableVisible = false;
      this.$refs[formName].resetFields();
    },
    // 预览文档
    hendelPreview(name, id, data) {
      // console.log('预览的id为 ', id)
      // console.log('预览的name为 ', name)
      // console.log('预览的data为 ', data)
      this.dialogPreview = true
      this.studyId = id
      // console.log(this.$refs)
      // console.log(this.$refs.mychild)
      setTimeout(() => {
        this.$refs.mychild.getResourse(id)
      }, 50)
    },
    hendelDelete(id) {
      // alert(id);
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.confirmDelete(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    confirmDelete(id) {
      let data = { token: this.$store.state.authority_management, id: id };
      this.$post('resources/delete', data).then(res => {
        if (res.data.status == 'success') {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getData();
        }

      });
    },
    handleModify(id) {
    },
    onModify: function () {
      this.dialogTableVisible2 = true
    },
    beforeUpload(file) {
      // // console.log(file);
      const isDoc = file.name.replace(/.+\./, "");
      if (['pdf', 'excel', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'].indexOf(isDoc) == '-1') {
        // // console.log('进入判断')
        this.$message({
          showClose: true,
          message: '上传文件类型错误！',
          type: 'warning'
        })
        return false
      }
      // // console.log(isDoc)
    },
    handleSizeChange(val) {
      this.resourceLength = val;
      this.offset = (this.currentPage - 1) * this.resourceLength
      this.getData();
    },
    //当文件超出限制
    handExceed() {
      this.$message({
        showClose: true,
        message: '每次只能上传一个文件！',
        type: 'warning'
      });
    },
    //移除文件时候
    handleRemove(file, fileList) {
      // // console.log(file, fileList);
    },
    handlePreview(file) {
      // // console.log(file);
    },
    handleSuccess(response, file, fileList) {
      // 上传成发生的事件
      // // console.log('文件上传成功');
      // // console.log(response.result);
      // // console.log(file);
      // // console.log(fileList);
      this.fileName = response.result
      // console.log(this.fileName)
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    getData() {
      // 获取数据
      let data = { token: this.$store.state.authority_management, type: 4, name: this.keywordName, offset: this.offset, length: this.resourceLength };
      this.$post('resources/shop_search', data).then(res => {
        this.tableData = res.data.result.data;
        this.totalPage = res.data.result.total;
      })
    },
    handelCurrentPage(index) {
      // // console.log(index)
      this.currentPage = index;
      this.offset = (index - 1) * this.resourceLength;
      this.getData();
    },

    // 批量上传文档资源时文件超出限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 99 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    }
  },
  created() {
    this.getData();
  }
}